var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-card',{staticClass:"tab_with_btn_holder"},[_c('vs-tabs',[_c('vs-tab',{attrs:{"label":"Invoice"}},[_c('Payslip')],1),_c('vs-tab',{attrs:{"label":"Payments Settings"}},[_c('Settings')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }